import { Injectable } from '@angular/core';
import { Careers } from '../models/careers';
import { CommonapiService } from './commonapi.service';

@Injectable({
  providedIn: 'root'
})
export class CareerService {
  public obj: Careers[] = new Array();

  constructor(
    private commonApiService: CommonapiService
  ) { }

  async getCareerList() {
    this.obj = new Array();
    const _obj = {
      Mode: "SEARCH",
      JobId: "0",
      JobTitle: "",      
      PageNumber: 1,
      NoOfRecordsPerPage: 100,
      DisplayFilter: 'Active',
      PropertyName: "JobId",
      SortingBy: false,
    };

    let _dt = await this.commonApiService.postData("api/MarketingApi/DBCareerOpportunites/", _obj).toPromise();

    console.log("career",_dt);

    if (_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlCareerList && _dt[0].dataSet.mlCareerList.length > 0) {
      const _data = _dt[0].dataSet.mlCareerList;

      console.log(_data);

      _data.forEach(element => {
        this.obj.push({
          id: element.jobId,
          title: element.jobTitle,
          location: element.location,
          link: element.link,          
          jd:element.jobDescription
        });
      });
    }

    return this.obj;
  }
}
